import Navigation from './Navigation';
import { SHOW_NAVIGATION } from '../config';

export default function Layout({ children }) {
    return (
        <div className="layout">
            {SHOW_NAVIGATION && <Navigation />}
            <main className="main-content">
                {children}
            </main>
        </div>
    );
}